export const F = {
  number(input?: string | number): string {
    if (!input) return '';
    return `${input}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },
};
